<template>
  <div id="component">
    <div class="container">
      <span class="welcome-message">{{$t('welcome')}}</span>
      <span class="company">falcon</span>
      <span class="username">{{username}}</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { notificationsRenderer } from '@/helpers/renderHelpers'
  import { SERVICE_DESK_URL } from '@/constants'

  export default {
    computed: {
      ...mapState('login', ['username'])
    },
    mounted () {
      const serviceDeskReminder = localStorage.getItem('serviceDeskReminder')
      if (serviceDeskReminder !== 'showed') {
        const link = `${this.$t('labels.common.service_desk')}: <a target="_blank" href="${SERVICE_DESK_URL}">Service desk</a>`
        notificationsRenderer(link, 'success')
        localStorage.setItem('serviceDeskReminder', 'showed')
      }
    }
  }
</script>

<style scoped>

  #component {
    height: 100%;
  }

  .container {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%
  }

  .container span {
    text-transform: uppercase;
    display: block;
  }

  .welcome-message {
    color: black;
    font-size: 60px;
    font-weight: 700;
    letter-spacing: 8px;
    margin-bottom: 20px;
    position: relative;
    animation: welcome 1s;
  }

  .company {
    font-size: 30px;
    animation: company 1.5s
  }

  .username {
    font-size: 50px;
    animation: username 1.5s;
    font-weight: 500;
  }

  @keyframes welcome {
    0% {
      margin-bottom: -40px;
    }
    30% {
      letter-spacing: 15px;
      margin-bottom: -40px;
    }
    85% {
      letter-spacing: 8px;
      margin-bottom: -40px;
    }
  }

  @keyframes company {
    0% {
      opacity: 0;
      margin-bottom: -40px;
    }
    85% {
      opacity: 0;
      margin-bottom: -40px;
    }
    100% {
      color: black;
      opacity: 1;
    }
  }

  @keyframes username {
    0% {
      opacity: 0
    }
    85% {
      opacity: 0;
    }
    100% {
      color: black;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Index.vue